import React, { useContext, useState } from 'react'
import { EPCRContext } from '../EPCR'
import SimpleTextField from '../../../../components/Forms/SimpleTextField'
//@MUI
import Alert from '@mui/material/Alert'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import EPCRCard from '../../../../components/Cards/EPCRCard'
import NextButton from '../NextButton'
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material'
import BigModal from '../../../../components/Modals/BigModal'

const Safeguarding = ({ onClose }) => {
  const { formValues, handleChange } = useContext(EPCRContext)
  const [selectedModule, setSelectedModule] = useState({})

  return (
    <Stack gap={2}>
      <EPCRCard>
        <Stack gap={1}>
          <FormControl>
            <InputLabel>
              Have any safeguarding concerns been identified during this episode
              of care?
            </InputLabel>
            <Select
              value={
                formValues?.safeguarding?.concernsAssessment ??
                // Legacy/mobile records only store the boolean
                (formValues?.safeguarding?.concerns === true
                  ? 'yes'
                  : formValues?.safeguarding?.concerns === false
                    ? 'no'
                    : '')
              }
              onChange={(e) => {
                handleChange({
                  moduleName: 'safeguarding',
                  field: 'concernsAssessment',
                  value: e.target.value,
                })
                handleChange({
                  moduleName: 'safeguarding',
                  field: 'concerns',
                  value: ['yes', 'unsure'].includes(e.target.value),
                })
              }}
              label="Have any safeguarding concerns been identified during this episode of care?"
            >
              <MenuItem value={'yes'}>
                Yes – safeguarding concern identified
              </MenuItem>
              <MenuItem value={'no'}>
                No concerns identified at this time
              </MenuItem>
              <MenuItem value={'unsure'}>
                Unsure / requires safeguarding review
              </MenuItem>
              <MenuItem value={'na'}>Not assessed / not applicable</MenuItem>
            </Select>
          </FormControl>
          {formValues?.safeguarding?.concerns && (
            <Stack gap={1}>
              <TextField
                value={formValues?.safeguarding?.concernsDetails ?? ''}
                onChange={(e) =>
                  handleChange({
                    moduleName: 'safeguarding',
                    field: 'concernsDetails',
                    value: e.target.value,
                  })
                }
                label="What are your concerns?"
                multiline
                minRows={3}
              />
              <FormControl>
                <Autocomplete
                  value={formValues?.safeguarding?.discussedWith ?? []}
                  onChange={(e, value) => {
                    handleChange({
                      moduleName: 'safeguarding',
                      field: 'discussedWith',
                      value: value,
                    })
                  }}
                  isOptionEqualToValue={(option, value) =>
                    formValues?.safeguarding?.discussedWith
                      ? option === value
                      : '' === value
                  }
                  multiple
                  options={[
                    'Event Clinical Lead',
                    'Safeguarding Lead',
                    'GP',
                    'Duty Social Worker',
                    'Police',
                  ]}
                  freeSolo
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Concerns Discussed With"
                      helperText="Press 'Enter' after submitting a custom option"
                    />
                  )}
                />
              </FormControl>
              <FormControl>
                <InputLabel>Has a Safeguarding Referral been made?</InputLabel>
                <Select
                  value={formValues?.safeguarding?.referralMade ?? ''}
                  onChange={(e) =>
                    handleChange({
                      moduleName: 'safeguarding',
                      field: 'referralMade',
                      value: e.target.value,
                    })
                  }
                  label="Has a Safeguarding Referral been made?"
                >
                  <MenuItem value={true}>Yes</MenuItem>
                  <MenuItem value={false}>No</MenuItem>
                </Select>
              </FormControl>
              {formValues?.safeguarding?.referralMade !== undefined && (
                <TextField
                  value={formValues?.safeguarding?.referralInfo ?? ''}
                  onChange={(e) =>
                    handleChange({
                      moduleName: 'safeguarding',
                      field: 'referralInfo',
                      value: e.target.value,
                    })
                  }
                  label={
                    formValues?.safeguarding?.referralMade === false
                      ? 'Why has a referral not been made?'
                      : 'Referral Information'
                  }
                  multiline
                  minRows={2}
                />
              )}
            </Stack>
          )}
        </Stack>
      </EPCRCard>
      {onClose && (
        <Button variant="contained" color="primary" fullWidth onClick={onClose}>
          Submit
        </Button>
      )}
    </Stack>
  )
}

export default Safeguarding
